export default "__VITE_ASSET__CkszEQ7g__"